import { motion } from "framer-motion";

export default function Zones() {
  return (
    <section id="zones" data-testid="zones-section" className="py-24 md:py-32 bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <img
          src="https://images.unsplash.com/photo-1596353087189-1a0d7be37593?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxzdHJhc2JvdXJnJTIwY2l0eXNjYXBlfGVufDB8fHx8MTc4MTQwMTAzOHww&ixlib=rb-4.1.0&q=85"
          alt="Strasbourg cityscape"
          className="w-full h-full object-cover grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-xs uppercase tracking-[0.3em] text-neutral-400 mb-5">03 · Zones d&apos;intervention</div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl md:text-7xl font-light tracking-tighter leading-[1.02] max-w-5xl"
        >
          Partout dans le <span className="text-[#FFB800]">Grand Est.</span><br />
          Et au-delà, <span className="text-[#FF2800]">en Europe.</span>
        </motion.h2>

        <p className="mt-10 text-lg text-neutral-300 max-w-2xl leading-relaxed">
          Strasbourg, Mulhouse, Colmar, Metz, Nancy, Reims — et toute destination
          européenne sur demande. Nous nous déplaçons jusqu&apos;à vous.
        </p>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {["Strasbourg", "Mulhouse", "Colmar", "Metz", "Nancy", "Reims", "Belfort", "Europe"].map((city) => (
            <div
              key={city}
              data-testid={`zone-${city.toLowerCase()}`}
              className="bg-black px-6 py-8 hover:bg-neutral-900 transition cursor-default"
            >
              <div className="font-display text-lg md:text-xl font-medium tracking-tight">{city}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mt-1">
                {city === "Europe" ? "Sur demande" : "Intervention"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
